import { Injectable } from '@angular/core'
import { MbAcademicDegreesAdapter } from './mb-academic-degrees.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbAcademicDegreesConnector {

  constructor (protected adapter: MbAcademicDegreesAdapter) {
  }

  get () {
    return this.adapter.load()
  }
}
